export const plusMinus = (val, up = true,
                          {
                              modificator = 1,
                              limit = 366,
                              lowerLimit = 1
                          } = {}) => {
    if (val === null) {
        return 1;
    }
    if (up && val <= limit) {
        val = Math.min(limit, val + modificator);
    } else if(!up && val >= lowerLimit){
        val = Math.max(lowerLimit, val - modificator);
    }
    return val;
};
